import {
  Col,
  Descriptions,
  Row,
} from 'antd';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { CONTRIBUYENTE_EJECUCIONES_MAPPING, normalizeObject } from '../utils/mapping';
import ModalJSON from './ModalJSON';
import ModalObservaciones from './ModalObservaciones';

const ContribuyenteDescriptor = ({
  contribuyente,
  setObservaciones,
}) => {
  const normalizedContribuyente = useMemo(() => normalizeObject(
    contribuyente, CONTRIBUYENTE_EJECUCIONES_MAPPING,
  ), [
    contribuyente,
  ]);

  return (
    <Row justify="end">
      <Col>
        {contribuyente?.id && (<ModalJSON json={contribuyente} label="contribuyente" />)}
      </Col>
      <Col>
        {contribuyente?.id && (
        <ModalObservaciones
          setter={setObservaciones}
          formItemName="observaciones_del_contribuyente"
          label="Agregar observaciones al contribuyente"
        />
        )}
      </Col>
      <Col span={24}>
        <Descriptions
          layout="vertical"
          size="small"
          bordered
          column={{
            xs: 1, sm: 2, md: 3, lg: 5,
          }}
          labelStyle={{ fontWeight: 'bold' }}
        >
          <Descriptions.Item label="ID del contribuyente" span={1}>
            {normalizedContribuyente.id_del_contribuyente || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Clave del contribuyente" span={1}>
            {normalizedContribuyente.clave_del_contribuyente || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Tipo de persona" span={1}>
            {normalizedContribuyente.tipo_de_persona || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Nombre / Razón Social" span={1}>
            {normalizedContribuyente.nombre_completo_del_contribuyente || ' - '}
          </Descriptions.Item>
          {/* <Descriptions.Item label="Apellido Paterno">
            {normalizedContribuyente.apellido_paterno_del_contribuyente || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Apellido Materno">
            {normalizedContribuyente.apellido_materno_del_contribuyente || ' - '}
          </Descriptions.Item> */}
          <Descriptions.Item label="Estatus del contribuyente" span={1}>
            {normalizedContribuyente.estatus_del_contribuyente || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="RFC" span={1}>
            {normalizedContribuyente.rfc_del_contribuyente || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="CURP" span={1}>
            {normalizedContribuyente.curp_del_contribuyente || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Fecha de constitución" span={1}>
            {normalizedContribuyente.fecha_de_constitucion || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Correo electrónico" span={2}>
            {normalizedContribuyente.correo_electronico_del_contribuyente || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Dirección" span={2}>
            {normalizedContribuyente.direccion_del_contribuyente?.toUpperCase() || ' - '}
          </Descriptions.Item>
          <Descriptions.Item label="Dirección de notificación" span={3}>
            {normalizedContribuyente.direccion_de_notificacion_del_contribuyente?.toUpperCase() || ' - '}
          </Descriptions.Item>
          {normalizedContribuyente?.observaciones_del_contribuyente && (
            <Descriptions.Item label="Observaciones" span={5} contentStyle={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              {normalizedContribuyente.observaciones_del_contribuyente || ' - '}
            </Descriptions.Item>
          )}
        </Descriptions>
      </Col>
    </Row>
  );
};

export default ContribuyenteDescriptor;

ContribuyenteDescriptor.propTypes = {
  contribuyente: PropTypes.shape({
    id: PropTypes.number,
  }),
  setObservaciones: PropTypes.func.isRequired,
};

ContribuyenteDescriptor.defaultProps = {
  contribuyente: null,
};
